import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { FULL_DAYS } from "../consts/strings";
import { WarningIcon } from "./Icons";
import { ConfirmDialog } from "./ConfirmDialog";
import { getSelectedPlanDay } from "../reducers/matrixProfile/selectors";

export const ConfirmDailyDriverSaveDilog = ({ open, onConfirm, onDecline }) => {
  const planDay = useSelector(getSelectedPlanDay);

  return (
    <ConfirmDialog
      open={!!open}
      onDecline={onDecline}
      onConfirm={onConfirm}
      width={420}
    >
      <Grid container>
        <Grid item xs={2}>
          <WarningIcon />
        </Grid>
        <Grid item xs={10}>
          {`This will permamently update the ${FULL_DAYS[planDay]} Depot Planning (7DD) Driver record.\r\nDo you wish to continue?`}
        </Grid>
      </Grid>
    </ConfirmDialog>
  );
};
